import handleCopyCustomElement from '../helpers/handle-copy-custom-element';

const copyHandler = (event) => {
  handleCopyCustomElement(event);
};

export default copyHandler;
